import axios from "axios";

export function usePdf() {
  const authHeaders = () => ({
    "Content-type": "application/json",
    Authorization: "Bearer " + localStorage.getItem("token"),
  });

  const downloadInvoicePdf = async (invoiceId, invoiceType) => {
    try {
      
      const responseBlob = await axios.post(
        process.env.VUE_APP_API_BASE + "auth/getInvoicePdf",
        { invoice_id: invoiceId },
        {
          headers: authHeaders(),
          responseType: "arraybuffer",
          dataType: "blob",
        }
      );

      const file = new Blob([responseBlob.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      const fileName = invoiceType + "_" + invoiceId;
      const link = document.createElement("a");
      link.href = fileURL;
      link.download = `${fileName}.pdf`;
      link.click();
      URL.revokeObjectURL(fileURL);
      
    } catch (err) {
      console.log("Something went wrong", err);
    }
  };

  return {
    downloadInvoicePdf,
  };
}
